export const slots = [
    {
        date: '2026-06-18',
        start: '17:00:00.000',
        duration: 6 * 60 * 1000,
        slots: 20,
        open: true,
    },
    {
        date: '2026-04-15',
        start: '17:00:00.000',
        duration: 6 * 60 * 1000,
        slots: 20,
        open: false,
    },
    {
        date: '2026-02-10',
        start: '16:40:00.000',
        duration: 10 * 60 * 1000,
        slots: 12,
        open: false,
    },
    {
        date: '2026-02-11',
        start: '17:00:00.000',
        duration: 10 * 60 * 1000,
        slots: 12,
        open: false,
    },
    {
        date: '2025-11-18',
        start: '16:40:00.000',
        duration: 12 * 60 * 1000,
        slots: 10,
        open: false,
    },
    {
        date: '2025-11-19',
        start: '17:00:00.000',
        duration: 12 * 60 * 1000,
        slots: 10,
        open: false,
    }
];
